//Somya se hi banvale page

import React, { useState } from "react";
import { Link } from "gatsby";
import Header from "../components/header";
import Modal from "../components/modal";
import { graphql } from "gatsby";
import * as styles from "./chugli.module.css";

let clickedIndex = -1;

export default function Chugli({ data }) {
  console.log(data);

  const [showModal, setShowModal] = useState(false);

  const toggleShowModal = () => {
    setShowModal(prevState => !prevState);
  };

  return (
    <div>
      <Link to="/">Home</Link>
      <Header headerText="Chugli" />
      <h2>Potential Candidates</h2>
      <div className={styles.outer}>
        {data.allMarkdownRemark.edges.map((value, index) => (
          <div className={styles.card}>
            <div className={styles.topRow}>
              <div className={styles.containerImage}>
                <img
                  src={value.node.frontmatter.image}
                  className={styles.candidateImage}
                ></img>
              </div>
              <div style={{ margin: "0px 15px" }}>
                <h2 style={{ margin: "7px 0" }}>
                  {value.node.frontmatter.name}
                </h2>
                <p>
                  {value.node.frontmatter.topics.map((row, index) => (
                    <span>
                      {index === 0 ? "" : ", "}
                      {row.heading}
                    </span>
                  ))}
                </p>
              </div>
            </div>

            <div className={styles.bottomRow}>
              <button
                onClick={() => {
                  console.log("index", index);
                  clickedIndex = index;
                  toggleShowModal();
                }}
                className={styles.button}
              >
                Details
              </button>
              <a
                href="https://meet.google.com/mnb-dudf-cxx"
                target="blank"
                style={{ margin: "0 10%" }}
              >
                Join Live session now
              </a>
            </div>
          </div>
        ))}
      </div>
      {showModal ? (
        <Modal height="50%" width="50%" toggleModal={toggleShowModal}>
          {data.allMarkdownRemark.edges[clickedIndex].node.frontmatter.name}
        </Modal>
      ) : null}
    </div>
  );
}

export const query = graphql`
  query {
    allMarkdownRemark(filter: { fileAbsolutePath: { regex: "//chugli//" } }) {
      edges {
        node {
          frontmatter {
            topics {
              heading
              points
            }
            name
            image
          }
        }
      }
    }
  }
`;
